import { createSlice } from "@reduxjs/toolkit";

export const kitchenTypologiesSlice = createSlice({
  name: "kitchenTypologies",
  initialState: {
    value: null,
  },
  reducers: {
    setKitchenTypologies: (state, action) => {
      state.value = action.payload;
    },
    resetKitchenTypologies: (state) => {
      state.value = null;
    },
  },
});

export const { setKitchenTypologies, resetKitchenTypologies } =
  kitchenTypologiesSlice.actions;
export default kitchenTypologiesSlice.reducer;
